
<div class="dtf-olp" style="background-color: #f2f1ec;">
    <div class="container_dashboard">
        <div class="dtf-dashboard" style="padding-top: 41px; padding-bottom: 0px;">
          
          <div class="example-button-row">
            <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState" (change)="onChangeButton($event)">
              <mat-button-toggle  [value]="toggleEnum.Option7" [class.selected]="selectedState === toggleEnum.Option7">Make a Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option1" [class.selected]="selectedState === toggleEnum.Option1">Principal Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option3" [class.selected]="selectedState === toggleEnum.Option3">Statement Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option6" [class.selected]="selectedState === toggleEnum.Option6">Recurring Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option4" [class.selected]="selectedState === toggleEnum.Option4" style="background-color: gray;">Manage Bank Profile</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option2" [class.selected]="selectedState === toggleEnum.Option2">Payment History</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option8" [class.selected]="selectedState === toggleEnum.Option8">Help</mat-button-toggle>
            </mat-button-toggle-group>
            </div>
        </div> 
      </div>
    <div *ngIf="blocked">
        <dtf-errorhandling [blocked]="blocked" [errorMessage]="errmsg"></dtf-errorhandling>
    </div>
    <div class="container_dashboard">
        <div class="dtf-sub-dashboard container_dashboard">
            <div *ngIf="!continue" class="card">
           <h1 *ngIf="!continue">Remove Bank Profile Verification</h1>
            <div class="row mt-4" *ngIf="!continue">
                <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                    <div class="pageStyle paragrapSpace">
                        {{REMOVEPROFILETEXT}}
                    </div>
                    <div class="Add_image paragrapSpace">
                        <div class="row">
                            <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 title">Bank Name</div>
                            <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 lightcon">{{deleteBankProfile.bankName}}</div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 title">Bank Account Type</div>
                            <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 lightcon">{{deleteBankProfile.acctDescription}}</div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 title">Bank Account Number </div>
                            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-6 lightcon">xxxxxxxxx{{deleteBankProfile.acctNum | slice:-4}}</div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 title">Routing Number</div>
                            <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 lightcon">xxxxx{{deleteBankProfile.routingNum | slice:-4}}</div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 title">Email Address</div>
                            <div class="col-lg-6 col-md-6 col-sm-4 col-xs-6 lightcon">{{deleteBankProfile.email}}</div>
                        </div>
                    </div>
                    <div style="display:flex;flex-direction: row;gap:10px" class="mt-4">
                        <div *ngIf="agentview ==='true'">
                            <input type="submit" value="Continue >" disabled class="mbfs-button" />
                        </div>
                        <div *ngIf="agentview !='true'">
                            <input type="submit" value="Continue >"  class="mbfs-button" (click)="onClickContinue()" />
                        </div>
                        <div><input type="button" value="Cancel >" class="mbfs-button" routerLink="/home/bankprofile" /> </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card" *ngIf="continue">
            <h1 class="header" *ngIf="continue">Remove Bank Profile Confirmation</h1>
            <div class="row mt-4" *ngIf="continue">
                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    <div class="pageStyle paragrapSpace">
                        {{REMOVEPROFILECONFIRMATIONTEXT}}
                    </div>
                    <br>
                    <button class="mbfs-button" (click)="Done()">Done</button>
                </div>
            </div>
        </div>
        </div>
    </div>
</div>
